export default __webpack_public_path__ + "static/media/s2.98b63012.jpg";